import React, { Component } from 'react';
import { connect } from 'react-redux';
import { popupSetRef, popupUnsetRef } from '~/store/actions/popup';
import './Popup.scss';

@connect(
  ({ popup }) => ({ popup }),
  (dispatch) => ({
    popupSetRef: (...args) => dispatch(popupSetRef(...args)),
    popupUnsetRef: (...args) => dispatch(popupUnsetRef(...args)),
  }),
)
class Popup extends Component {
  componentDidMount() {
    const { popupSetRef } = this.props;
    popupSetRef(this.ref);
  }

  componentWillUnmount() {
    const { popupUnsetRef } = this.props;

    this.ref = null;
    popupUnsetRef();
  }

  render() {
    const {
      popup: { show },
    } = this.props;

    return (
      <div className="popup">
        <span ref={(ref) => (this.ref = ref)} className={show ? 'popup-overlay show' : 'popup-overlay'} />
      </div>
    );
  }
}

export default Popup;
